module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ambis-meter-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Ambis Meter',
          to: {
            path: '/ambis-meter'
          },
        },
        {
          text: 'Tambah Ambis Meter'
        } ],
      "divider": ">"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s("Tambah Ambis Meter") + "\n    ")]), _vm._v(" "), _c('v-card', [_c('v-stepper', {
    staticClass: "pa-0",
    attrs: {
      "flat": "",
      "color": "blew"
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-card-text', [_c('v-stepper-header', {
    staticStyle: {
      "box-shadow": "none"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 1,
      "step": "1"
    }
  }, [_vm._v("\n                        Periode\n                    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 2,
      "step": "2"
    }
  }, [_vm._v("\n                        Kelas dan Misi\n                    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v(" Level ")])], 1)], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('app-periodeform', {
    on: {
      "completed": function($event) {
        return _vm.goToNextStep()
      },
      "uncompleted": function($event) {
        _vm.step--
      }
    }
  })], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('app-missionform', {
    on: {
      "completed": function($event) {
        return _vm.goToNextStep()
      },
      "uncompleted": function($event) {
        _vm.step--
      }
    }
  })], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('app-levelform', {
    on: {
      "completed": function($event) {
        return _vm.goToNextStep()
      },
      "uncompleted": function($event) {
        _vm.step--
      }
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e1c41df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_meter/components/AmbisMeterForm.vue
// module id = 960
// module chunks = 1